import React,{useEffect,useRef} from "react";
import Button from "../../../../UI/Button/Button";
import classes from "./AppointmentForm.module.css";

import gsap from "gsap";

const AppointmentForm = (props) => {
    useEffect(()=>{
        // console.log(q(classes.label))
        const rows = document.getElementsByClassName(classes.row)
        // console.log(rows)
        gsap.from(rows,{
            delay:0.5,
            duration:0.5,
            opacity: 0,
            xPercent:100,
            stagger:0.1,
        })

    },[])
    // console.log(props.doctor)
  return (
    <div className={classes.container}>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>العيادة:</div>
        <div className={classes.value}>{props.clinic}</div>
      </span>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>الدكتور:</div>
        <div className={classes.value}>{props.doctor}</div>
      </span>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>الإسم:</div>
        <input className={classes.textField} />
      </span>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>رقم الهاتف:</div>
        <input type="tel" className={classes.textField} />
      </span>
      
        <h4>سيتم التواصل معكم لتحديد الموعد</h4>

      <div className={classes.actions}>
        <Button className={classes.button}>Submit</Button>
      </div>
    </div>
  );
};
export default AppointmentForm;
